import Network from "../utils/Network";

export default class CarService {
  network: Network;
  constructor() {
    this.network = Network.getInstance();
  }

  async models() {
    return await this.network.getRequest('models');
  }

  async motors(model: string) {
    return await this.network.getRequest('motors', `model=${model}`);
  }

  async transmissions(model: string, motor: string) {
    return await this.network.getRequest('transmissions', `model=${model}&motor=${motor}`);
  }

  async drives(model: string, motor: string, transmission: string) {
    return await this.network.getRequest('drives', `model=${model}&motor=${motor}&transmission=${transmission}`);
  }

  async pms(model: string, motor: string, transmission: string, drive: string) {
    return await this.network.getRequest('pms', `model=${model}&motor=${motor}&transmission=${transmission}&drive=${drive}`);
  }

  async pm(model: string, motor: string, transmission: string, drive: string, pm: string) {
    return await this.network.getRequest('pm', `model=${model}&motor=${motor}&transmission=${transmission}&drive=${drive}&pm=${pm}`);
  }

  async writeForPM(data: App.IObject) {
    return await this.network.postRequestFD('site/send-user-data', data, {}, true);
  }
}